import {
  useGetAvailableProviderContextsQuery,
  useSwitchProviderContextMutation,
  useGetActiveProviderContextQuery,
  useGetMyMembershipsQuery,
  Feature,
  MembershipStatus,
} from '../../generated/graphql';
import { customToast } from '../components/ToastAlert/customToast';
import { useFeatureFlags } from '../../contexts/FeatureFlagContext';

export const useProviderContext = () => {
  const { isFeatureEnabled } = useFeatureFlags();
  const isEnabled = isFeatureEnabled(Feature.EnableSwitchingProviderContext);

  const { data: activeContextData } = useGetActiveProviderContextQuery({
    skip: !isEnabled,
  });
  const { data, loading } = useGetAvailableProviderContextsQuery({
    skip: !isEnabled,
  });
  const { data: membershipsData, loading: membershipsLoading } =
    useGetMyMembershipsQuery({
      skip: !isEnabled,
      variables: { input: { statuses: [MembershipStatus.Active] } },
    });
  const [switchProviderContext] = useSwitchProviderContextMutation();

  const activeProviderId = activeContextData?.activeProviderContext?.id;
  const primaryProviderId =
    membershipsData?.myMemberships?.find((m) => m.isPrimaryProvider)?.provider
      ?.id ?? null;

  const handleContextSwitch = async (providerId: string) => {
    if (!isEnabled) return;

    try {
      const result = await switchProviderContext({
        variables: {
          input: {
            providerId,
          },
        },
      });

      if (result.data?.switchProviderContext.success) {
        // Hard refresh to ensure all state is reset with the new provider context
        window.location.reload();
      } else {
        customToast.error('Failed to switch provider context');
      }
    } catch (err) {
      customToast.error('An error occurred while switching provider context');
    }
  };

  return {
    availableContexts: data?.availableProviderContexts ?? [],
    loading: loading || membershipsLoading,
    handleContextSwitch,
    activeProviderId,
    primaryProviderId,
    isEnabled,
  };
};
